import React from "react";
import { cn } from "@/lib/utils";

/**
 * Botones de respuesta táctiles con color (✅🟢🔴🟣⛔️🟨⬜️…).
 * Selección única: el botón activo se pinta con el color de la opción y se "hunde".
 */
export function ToggleField({ field, value, onChange }) {
  const cols = field.opts.length === 2 ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-3";
  return (
    <div className="flex flex-col gap-2.5" data-testid={`toggle-${field.name}`}>
      <span className="text-[13.5px] font-heading font-semibold text-foreground leading-snug">
        {field.lab}
        {field.req ? <span className="text-destructive ml-0.5">*</span> : null}
      </span>
      <div className={cn("grid gap-2.5", cols)}>
        {field.opts.map((o) => {
          const on = value === o.v;
          return (
            <button
              type="button"
              key={o.v}
              data-testid={`opt-${field.name}-${o.v}`}
              onClick={() => onChange(field.name, on ? "" : o.v)}
              style={on ? { background: o.c, borderColor: o.c } : {}}
              className={cn(
                "inline-flex items-center justify-center gap-2 min-h-[54px] px-3 rounded-[calc(var(--radius)-0.3rem)]",
                "text-[14.5px] font-heading font-semibold border-2 transition-[transform,box-shadow,background-color,color,border-color] duration-150",
                on
                  ? "text-white translate-y-[3px] shadow-none"
                  : "bg-card text-foreground border-border shadow-[0_3px_0_0_hsl(var(--border))] active:translate-y-[3px] active:shadow-none"
              )}
            >
              <span role="img" aria-label={o.t} className="text-[18px] leading-none">{o.e}</span>
              {o.t}
            </button>
          );
        })}
      </div>
    </div>
  );
}
